import { computed, Injectable, signal } from '@angular/core';

interface TagGridWithInputComponentState {
  userAddedOption: string;
  userAddedOptions: string[];
}

@Injectable()
export class TagGridWithInputService {
  private state = signal<TagGridWithInputComponentState>({
    userAddedOption: null,
    userAddedOptions: [],
  });

  public currentlyAddedOption = computed(() => this.state().userAddedOption);
  public userAddedOptions = computed(() => this.state().userAddedOptions);

  public setUserAddedOption(option: string): void {
    this.state.update((state) => ({ ...state, userAddedOption: option }));
  }

  public setUserAddedOptions(options: string[]): void {
    this.state.update((state) => ({ ...state, userAddedOptions: options }));
  }

  /**
   * Adds the specified option to the selection if it is not already added.
   *
   */

  public addUserAddedOption(): void {
    const newOption = this.state().userAddedOption;
    if (!newOption) return;

    this.state.update((state) => {
      if (!state.userAddedOptions.some((userAddedOption) => userAddedOption === newOption)) {
        return {
          ...state,
          userAddedOptions: [...state.userAddedOptions, newOption],
        };
      }
      return state;
    });
  }

  /**
   * Removes the specified option from the selection.
   *
   * @param option - The option to be removed from the selection.
   */
  public removeSelection(option: string): void {
    this.state.update((state) => ({
      ...state,
      userAddedOptions: state.userAddedOptions.filter((userAddedOption) => userAddedOption !== option),
    }));
  }
}
